import FormatIndentIncreaseIcon from '@mui/icons-material/FormatIndentIncreaseRounded';
import { LexicalEditor, INDENT_CONTENT_COMMAND } from 'lexical';
import { StyledButton } from '../../styles';

interface Props {
  blockType: string;
  isEditable: boolean;
  activeEditor: LexicalEditor;
}

export default function IndentIncreaseButton(props: Props) {
  const { blockType, isEditable, activeEditor } = props;
  return (
    <StyledButton
      disabled={!isEditable || (blockType !== 'bullet' && blockType !== 'number')}
      onClick={() => {
        activeEditor.dispatchCommand(INDENT_CONTENT_COMMAND, undefined);
      }}
      className="toolbar-item"
      title="Increase Indent"
      type="button"
      aria-label="Increase indent"
    >
      <FormatIndentIncreaseIcon />
    </StyledButton>
  );
}
